import { enumPicMask, NS_SVG, SVGDefaultMaskStrokeWidth } from "../constants";
import { SVG_CreateCircleMask } from "./SVG_CreateCircleMask";
import { SVG_ShiftY } from "./SVG_ShiftY";
import { SVG_ShiftX } from "./SVG_ShiftX";
import { SVG_CreateClipRect } from "./SVG_CreateClipRect";
import { SVG_DrawCircle } from "./SVG_DrawCircle";
import { getBase64Image } from "./getBase64Image";

export function SVG_DrawImage(
  x,
  y,
  width,
  height,
  clipRect,
  pictureMask,
  maskBorderColor,
  theImage,
  layer,
  svgElement,
  highRes = false
) {
  x = SVG_ShiftX(x, svgElement);
  y = SVG_ShiftY(y, svgElement);

  var imageObj = document.createElementNS(NS_SVG, "image");
  imageObj.setAttribute("x", x);
  imageObj.setAttribute("y", y);
  imageObj.setAttribute("width", width);
  imageObj.setAttribute("height", height);
  imageObj.setAttribute("preserveAspectRatio", "none");

  var imageData = getBase64Image(theImage, highRes);
  imageObj.setAttribute("xlink:href", imageData);

  if (clipRect) {
    SVG_CreateClipRect(clipRect, imageObj, svgElement);
  }

  if (pictureMask === enumPicMask.circle) {
    var cx = x + width / 2;
    var cy = y + height / 2;
    var radius = Math.min(width / 2, height / 2) - SVGDefaultMaskStrokeWidth;
    SVG_CreateCircleMask(clipRect, cx, cy, radius, imageObj, svgElement);
  }

  svgElement.appendChild(imageObj);

  if (pictureMask === enumPicMask.circle) {
    var stroke = maskBorderColor;
    var circleObj = SVG_DrawCircle(cx, cy, radius, stroke, SVGDefaultMaskStrokeWidth, svgElement);

    if (clipRect) {
      SVG_CreateClipRect(clipRect, circleObj, svgElement);
    }

    // draw circle border
  }
}
